export default __webpack_public_path__ + "67b9aa31488ea987150a9136801f0b11.png";